import { Injectable } from '@angular/core'
import randomBytes from 'randombytes'
import { SubSink } from 'subsink'

export function isUndefined (value: any) {
  return typeof value === 'undefined'
}

export function isNull (value: any) {
  return value === null
}

export function extractDeepPropertyByMapKey (obj: any, map: string): any {
  const keys = map.split('.')
  const head = keys.shift()

  return keys.reduce((prop: any, key: string) => {
    return !isUndefined(prop) && !isNull(prop) && !isUndefined(prop[key]) ? prop[key] : undefined
  }, obj[head ?? ''])
}

@Injectable()
export abstract class BaseComponent {
  componentID = randomBytes(32).toString('hex')
  protected subs = new SubSink()

  ngOnDestroy () {
    this.subs.unsubscribe()
  }
}

/// Remap some items in an array and return a new array
/// Useful for "immutable" component properties
export function replaceArrayItems<T> (array: T[], predicate: (T) => boolean, remap: (T) => T): T[] {
  return array.map(item => predicate(item) ? remap(item) : item)
}

export function isValidRegex (value: string): boolean {
  try {
    new RegExp(value) // eslint-disable-line
    return true
  } catch (error) {
    return false
  }
}

export function filterFalsy<T> (array: (T|null|undefined)[]): T[] {
  return array.filter(Boolean) as T[]
}
